<template>
  <section class="trusted-companies-section">
    <div class="container">
      <div class="section-header">
        <h2>{{ content.header.title }}</h2>
      </div>
      
      <div class="companies-slider swiper" ref="companiesSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(company, index) in content.companies" :key="index">
            <div class="company-logo">
              <img :src="company.logo" :alt="company.name" />
            </div>
          </div>
        </div>
        <!-- Navigation buttons -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: 'AIMLItsTrustComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup() {
    const companiesSwiper = ref(null)

    onMounted(() => {
      initCompaniesSwiper()
    })

    const initCompaniesSwiper = () => {
      setTimeout(() => {
        const checkSwiper = () => {
          if (window.Swiper) {
            companiesSwiper.value = new window.Swiper('.companies-slider', {
              loop: true,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                0: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 30,
                }
              }
            });
          } else {
            setTimeout(checkSwiper, 100);
          }
        };
        checkSwiper();
      }, 500);
    }

    return {
      companiesSwiper
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Trusted Companies Section */
.trusted-companies-section {
  padding: 100px 0;
  background: linear-gradient(145deg, #0a0f1c, #1a2332);
  color: #fff;
}

.trusted-companies-section .section-header {
  text-align: center;
  margin-bottom: 60px;
}

.trusted-companies-section .section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.companies-slider {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;
  position: relative;
}

.company-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 1px solid rgba(246, 236, 79, 0.1);
}

.company-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.company-logo img {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
  filter: grayscale(100%);
  transition: all 0.3s ease;
}

.company-logo:hover img {
  filter: grayscale(0%);
}

/* Swiper Navigation Buttons */
.swiper-button-next,
.swiper-button-prev {
  background: #F6EC4F;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #000;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(246, 236, 79, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  background: #FFD700;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 8px 25px rgba(246, 236, 79, 0.4);
}

.swiper-button-prev {
  left: 10px;
}

.swiper-button-next {
  right: 10px;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-family: 'Font Awesome 6 Free';
  font-weight: 900;
  font-size: 16px;
}

.swiper-button-prev:after {
  content: '\f053';
}

.swiper-button-next:after {
  content: '\f054';
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .trusted-companies-section {
    padding: 60px 0;
  }
  
  .trusted-companies-section .section-header h2 {
    font-size: 36px;
  }
  
  .company-logo {
    height: 100px;
    padding: 15px;
  }
  
  .company-logo img {
    max-height: 60px;
  }
  
  .companies-slider {
    padding: 0 20px;
  }
  
  .swiper-button-prev {
    left: 5px;
  }
  
  .swiper-button-next {
    right: 5px;
  }
}
</style>
